export default __webpack_public_path__ + "static/media/S-023.8dc79938.png";